export enum TacticSettingsViewModeEnum {
  CREATE = 'create',
  EDIT = 'edit',
}
